"use client";

import LocaleSwitcher from "@/components/Footer/LocaleSwitcher";
import { FooterLinks } from "@/types/Footer";
import { CTA } from "@/types";
import OtBannerLink from "../OtBannerLink";

type Props = {
  links?: FooterLinks[];
  isSpanishLocale: boolean;
};
export default function SecondaryLinks({ links, isSpanishLocale }: Props) {
  if (!links) return null;
  const edxLinks = links.find((section) => section?.label === "edx");
  const connectLinks = links.find(
    (section) => section?.label === (isSpanishLocale ? "Contacto" : "Connect"),
  );
  const legalLinks = links.find(
    (section) =>
      section?.label === (isSpanishLocale ? "Avisos legales" : "Legal"),
  );
  return (
    <div className="flex flex-wrap justify-between">
      <div className="mr-12 mb-6">{getSecondaryLinks(edxLinks)}</div>
      <div className="mr-12 mb-6">{getSecondaryLinks(connectLinks)}</div>
      <div className="mb-6 grow">{getSecondaryLinks(legalLinks)}</div>
      <div className="mb-6 flex">
        <LocaleSwitcher />
      </div>
    </div>
  );
}

const getSecondaryLinks = (linkSection: FooterLinks) => {
  return (
    <>
      <span className="text-base text-left pb-6 mt-0 font-bold">
        {linkSection?.label}
      </span>
      <ul className="my-6 list-none">
        {linkSection?.childItems.nodes.map((link: CTA) => (
          <li key={link.label} className="mb-2 hover:underline text-base">
            {link.label === "Your Privacy Choices" ? (
              <OtBannerLink
                href={link.url}
                text={link.label}
                className="text-white hover:text-white"
              />
            ) : (
              <a className="text-white hover:text-white" href={link.url}>
                {link.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </>
  );
};
